import jwtDecode from 'jwt-decode';
import { AccessTokenPayload } from '../types';

export function isAccessTokenValid(token: string) {
  const decodedToken = jwtDecode<AccessTokenPayload>(token);
  return Boolean(
    decodedToken &&
      decodedToken.exp &&
      (decodedToken.exp as number) > Math.floor(Date.now() / 1000),
  );
}

export function isImpersonator(token: string) {
  const decodedToken = jwtDecode<AccessTokenPayload>(token);
  return Boolean(decodedToken && decodedToken.roles?.includes('impersonator'));
}
